import {GenericVehiclesError} from './GenericVehiclesError.js'
import GetBodyTypeInfoVehiclesError from './GetBodyTypeInfoVehiclesError.js'
import GetBodyTypeUrlParamsVehiclesError from './GetBodyTypeUrlParamsVehiclesError.js'
import GetBrandModelInfoVehiclesError from './GetBrandModelInfoVehiclesError.js'
import GetMarketedMakesVehiclesError from './GetMarketedMakesVehiclesError.js'
import {GetModelDetailContentError} from './GetModelDetailContentError.js'
import {GetModelDetailContentNotFoundError} from './GetModelDetailContentNotFoundError.js'
import GetModelInfoVehiclesError from './GetModelInfoVehiclesError.js'
import GetModelsGroupedByBodyTypeDoorsVehiclesError from './GetModelsGroupedByBodyTypeDoorsVehiclesError.js'
import {GetPaginationSearchUrlVehiclesError} from './GetPaginationSearchUrlVehiclesError.js'
import {GetSubscriptionMakesNotFoundVehiclesError} from './GetSubscriptionMakesNotFoundVehiclesError.js'
import {GetSubscriptionMakesVehiclesError} from './GetSubscriptionMakesVehiclesError.js'
import {GetSubscriptionModelsNotFoundVehiclesError} from './GetSubscriptionModelsNotFoundVehiclesError.js'
import {GetSubscriptionModelsVehiclesError} from './GetSubscriptionModelsVehiclesError.js'
import GetVersionInfoVehiclesError from './GetVersionInfoVehiclesError.js'
import {NotFoundCompetitorsVehiclesError} from './NotFoundCompetitorsVehiclesError.js'
import {NotFoundVehiclesError} from './NotFoundVehiclesError.js'

export default class VehiclesErrorsFactory {
  static getBrandModelInfoVehiclesError = msg => new GetBrandModelInfoVehiclesError(msg)

  static getMarketedMakesVehiclesError = msg => new GetMarketedMakesVehiclesError(msg)

  static getModelsGroupedByBodyTypeDoorsVehiclesError = msg => new GetModelsGroupedByBodyTypeDoorsVehiclesError(msg)

  static getBodyTypeUrlParamsVehiclesError = msg => new GetBodyTypeUrlParamsVehiclesError(msg)

  static getModelInfoVehiclesError = msg => new GetModelInfoVehiclesError(msg)

  static getBodyTypeInfoVehiclesError = msg => new GetBodyTypeInfoVehiclesError(msg)

  static getSubscriptionMakesVehiclesError = msg => new GetSubscriptionMakesVehiclesError(msg)

  static getSubscriptionMakesNotFoundVehiclesError = msg => new GetSubscriptionMakesNotFoundVehiclesError(msg)

  static getSubscriptionModelsVehiclesError = msg => new GetSubscriptionModelsVehiclesError(msg)

  static getSubscriptionModelsNotFoundVehiclesError = msg => new GetSubscriptionModelsNotFoundVehiclesError(msg)

  static getModelDetailContentError = msg => new GetModelDetailContentError(msg)

  static getModelDetailContentNotFoundError = msg => new GetModelDetailContentNotFoundError(msg)

  static getVersionInfoVehiclesError = msg => new GetVersionInfoVehiclesError(msg)

  static genericVehiclesErrorFactory = msg => new GenericVehiclesError(msg)

  static notFoundCompetitorsVehiclesErrorFactory = msg => new NotFoundCompetitorsVehiclesError(msg)

  static notFoundVehiclesErrorFactory = msg => new NotFoundVehiclesError(msg)

  static getPaginationSearchUrlVehiclesError = msg => new GetPaginationSearchUrlVehiclesError(msg)
}
